import type { FaireProductEntity } from "../../entity_types/product";

export const bath_4: FaireProductEntity = {
  token: "bath-4",
  type: "product",
  name: "Citrus Hand Soap",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/609c7b136226be66209656e2a6f9abba1bf6ce8965f5baf509f9ba2d9f7446a9.jpeg",
  priceDollars: 9,
  msrpDollars: 15,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
